import React from 'react';
import './App.css';
import ForecastDashboard from './components/ForecastDashboard';

function App() {
  return (
    <div className="App">
      <ForecastDashboard />
    </div>
  );
}

export default App;
